module.exports = __webpack_public_path__ + "static/media/29ADMSPC20.32acf314.jpg";